import { Component, Input } from '@angular/core';

@Component({
  selector: 'card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class Card {

  @Input() data: any | undefined;

  constructor() {
  
  }
}
